/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Waiting_For_DataInputs */



/**
* | output |
* | --- |
* | "Waiting for tournament data..." |
*
* @param {Tournament_Waiting_For_DataInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_waiting_for_data = /** @type {((inputs?: Tournament_Waiting_For_DataInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Waiting_For_DataInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En attente des données du tournoi...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esperando datos del torneo...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Aguardando dados do torneio...")
	if (locale === "it") return /** @type {LocalizedString} */ ("In attesa dei dati del torneo...")
	return /** @type {LocalizedString} */ ("Waiting for tournament data...")
});